import { usePackage } from "./PackageContext";

export const useSubscription = () => {
    const { packageDetails } = usePackage();

    const isLoading = packageDetails == null;

    const isActive =
        !!(packageDetails && packageDetails.status === "Active");

    const isPremium =
        !!(
            isActive &&
            ["Premium", "Growth", "Advanced"].includes(packageDetails?.package_name)
        );

    const isGrowth =
        !!(
            isActive &&
            ["Growth", "Advanced"].includes(packageDetails?.package_name)
        );

    const isFree = !isActive;

    return {
        packageDetails,
        isLoading,
        isPremium,
        isGrowth,
        isFree,
    };
};